import { render, staticRenderFns } from "./order_return_edit.vue?vue&type=template&id=a4f2419c&scoped=true"
import script from "./order_return_edit.vue?vue&type=script&lang=js"
export * from "./order_return_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f2419c",
  null
  
)

export default component.exports